// src/components/ImageField.jsx
// حقل صورة اختياري: اختيار + معاينة + استبدال، ويعرض الصورة الحالية في وضع التعديل.
import { useEffect, useState } from "react";
import { Image as ImageIcon, X } from "lucide-react";

export default function ImageField({
  label = "الصورة (اختياري)",
  file,
  existingUrl,
  onChange,
}) {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!file) {
      setPreview(null);
      return;
    }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const shown = preview || existingUrl || null;

  const pick = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!f.type.startsWith("image/")) {
      alert("اختر ملف صورة فقط");
      return;
    }
    onChange(f);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>

      {shown ? (
        <div className="space-y-2">
          <div className="relative inline-block max-w-full">
            <img
              src={shown}
              alt=""
              className="max-h-48 rounded-xl border border-gray-200 object-contain bg-white"
            />
            {file && (
              <button
                type="button"
                onClick={() => onChange(null)}
                title="إلغاء الصورة الجديدة"
                className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white rounded-full p-1"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
          <div>
            <label className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-200 text-xs text-gray-600 cursor-pointer hover:bg-gray-50">
              <ImageIcon className="w-3.5 h-3.5" />
              {file ? "تغيير الصورة" : "استبدال الصورة الحالية"}
              <input type="file" accept="image/*" onChange={pick} className="hidden" />
            </label>
          </div>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl py-5 cursor-pointer hover:border-blue-400 transition-colors">
          <ImageIcon className="w-7 h-7 text-gray-400 mb-1" />
          <span className="text-sm text-gray-500">اضغط لرفع صورة</span>
          <input type="file" accept="image/*" onChange={pick} className="hidden" />
        </label>
      )}
    </div>
  );
}
